import { render, staticRenderFns } from "./UserClient.vue?vue&type=template&id=1825f888"
import script from "./UserClient.vue?vue&type=script&lang=js"
export * from "./UserClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports